<template>
  <div class="content">
    <img :src="paySuccess"/>
    <h2>{{$t('恭喜报名成功')}}</h2>
    <a-dropdown>
      <a-menu slot="overlay" @click="printExcel($event,'signUp')">
        <a-menu-item key="1">
          {{$t('官方打印版')}}
        </a-menu-item>
        <!-- <a-menu-item key="2">
          {{$t('完整信息版')}}
        </a-menu-item> -->
      </a-menu>
      <a-button icon="download"> {{$t('下载报名列表')}} <a-icon type="down" /> </a-button>
    </a-dropdown>
    <!-- <a-button style="margin-left: 10px;" icon="download" type="primary" @click="printExcel('signUp')">下载报名列表</a-button> -->
    <a-divider type="vertical" />
    <a-button style="" icon="download" type="primary" @click="printExcel(null,'insurance')">{{$t('下载保险凭证')}}</a-button>
  </div>
</template>
<script>
import store from '@/store'
export default {
  data () {
    return {
      paySuccess: require('@comm/assets/join/pay_success.png'),
      accountId: store.getters['user/accountId'],
      agencyId: Number(this.$route.query.agencyId)
    }
  },
  methods: {
    printExcel (type, downloadType) {
      console.log(type)
      if (downloadType === 'signUp') {
        // 个人报名
        if (Number(this.$route.query.programId) === 21) {
          this.$api.join.exportSignDataExcelV1({matchId: this.$route.query.matchId, agencyId: this.$route.query.agencyId, type: type.key}).then(res => {
            this.readerDownload(res, downloadType)
          }).catch(err => {
            console.log(err)
          })
        } else if (this.agencyId === -1) {
          this.$api.join.exportPersonalSignDataExcel({matchId: this.$route.query.matchId, customerId: this.accountId}).then(res => {
            this.readerDownload(res, downloadType)
          }).catch(err => {
            console.log(err)
          })
        } else {
          this.$api.join.exportSignDataExcel({matchId: this.$route.query.matchId, agencyId: this.$route.query.agencyId, type: type.key}).then(res => {
            this.readerDownload(res, downloadType)
          }).catch(err => {
            console.log(err)
          })
        }
      } else {
        // 个人报名
        if (this.agencyId === -1) {
          this.$api.join.exportPersonalInsurancePdf({matchId: this.$route.query.matchId, customerId: this.accountId}).then(res => {
            this.readerDownload(res, downloadType)
          }).catch(err => {
            console.log(err)
          })
        } else {
          this.$api.join.exportInsurancePdf({matchId: this.$route.query.matchId, agencyId: this.$route.query.agencyId}).then(res => {
            this.readerDownload(res, downloadType)
          }).catch(err => {
            console.log(err)
          })
        }
      }
    },
    readerDownload (res, downloadType) {
      let type = res.type
      // 如果返回的blob体的type是application/json类型，说明导出过程有异常，导出失败
      if (type.includes('application/json')) {
        let reader = new FileReader()
        var _this = this
        reader.onload = function (event) {
          let content = reader.result
          let message = JSON.parse(content).msg // 错误信息
          _this.$message.error(message)
        }
        reader.readAsText(res)
      } else {
        let blob = new Blob([res])
        let url = window.URL.createObjectURL(blob)
        let link = document.createElement('a')
        link.href = url

        link.download = downloadType == 'signUp' ? '报名数据.xls' : '保险凭证.pdf' // 下载后文件名
        document.body.appendChild(link)
        link.click() // 点击下载
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .content {
    text-align: center;
    margin-top: 100px;
    h2 {
      margin-top: 20px;
      color: #1890ff;
      font-weight: bold;
    }
  }
</style>



// WEBPACK FOOTER //
// src/comm/components/join/pay/PaySuccess.vue